/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _7 = "@media (min-width:48rem){._15fl1ejb{margin-top:var(--ds-space-300,24px)}}";
const _6 = "._19pkutpp{margin-top:var(--ds-space-150,9pt)}";
const _5 = "._1bsb1osq{width:100%}";
const _4 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { AppTileGridSkeleton, AppTileSize } from '@atlassian/mpac-app-tile';
import { breakpointValues, Stripe, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_IDS } from '../../testids';
import { SectionHeader, TrustSignalsWrapper } from './TrustSignalsSection';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const HeaderContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderContainer.displayName = 'HeaderContainer';
}
const TextContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _, _2, _3, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi _1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _19pkutpp _15fl1ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TextContainer.displayName = 'TextContainer';
}
const HeaderSkeleton = () => {
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  return /*#__PURE__*/_jsxs(HeaderContainer, {
    children: [/*#__PURE__*/_jsx(Stripe, {
      width: "50%"
    }), /*#__PURE__*/_jsx(TextContainer, {
      children: isTablet ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          height: "14px",
          width: "75%"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "14px",
          width: "70%"
        })]
      }) : isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          height: "12px"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "12px"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "12px"
        })]
      }) : /*#__PURE__*/_jsx(Stripe, {
        width: "75%",
        height: "14px"
      })
    })]
  });
};
export const TrustSignalsSectionSkeleton = () => {
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": TEST_IDS.TRUST_SIGNAL_SKELETON,
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(HeaderSkeleton, {})
    }), /*#__PURE__*/_jsx(TrustSignalsWrapper, {
      children: /*#__PURE__*/_jsx(AppTileGridSkeleton, {
        tileCount: 3,
        size: AppTileSize.SMALL
      })
    })]
  });
};